module.exports = __webpack_public_path__ + "static/media/1.6eb80962.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/1.mp3
// module id = 477
// module chunks = 0